.uic-app-user-info {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;

    &__content {
        flex: 1 1 auto;
        box-sizing: border-box;
        padding: 10px 0;
    }

    &__row {
        width: 100%;
        word-break: break-word;

        &:not(:last-of-type) {
            margin-bottom: 1em;
        }
    }

    &__avatar {
        flex: 0 0 auto;
        box-sizing: border-box;
        width: 90px;
        padding: 0 20px 0 10px;

        uic-icon {
            width: 56px;
            height: 56px;
            border-radius: 56px;
            color: var(--uic-color-blue4);
            background-color: var(--uic-color-grey1);
            position: relative;
            overflow: hidden;
        }

        svg {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 68px;
            height: 68px;
            transform: translate(-50%, -50%);
        }
    }

    &--hidden {
        display: none;
    }
}
